<template>
    <MetricsDashboard :entity-id="entityId" :entity-type="entityType">
        <template #child-section="{ hours, stekRelease }">
            <AllDomainsSection
                v-if="entityType === 'stek'"
                :hours="hours"
                :stek-release="stekRelease"
            />
        </template>
    </MetricsDashboard>
</template>

<script setup lang="ts">
import AllDomainsSection from "./AllDomainsSection.vue";
import MetricsDashboard from "./MetricsDashboard.vue";

defineOptions({
    name: "StekDashboard",
});

defineProps<{
    entityId: string;
    entityType: string;
}>();
</script>
